(function () {
  'use strict';

  const container = document.querySelector('.fh-collection-seo');
  if (!container) return;

  const prose = container.querySelector('.fh-collection-seo__prose');
  const faqContainer = container.querySelector('.fh-collection-seo__faq');
  if (!prose || !faqContainer) return;

  const faqHeadingText = container.dataset.faqHeading || '';
  const children = Array.from(prose.children);

  // Helper: Check if element starts with bold text (strong or b)
  function getLeadingBold(el) {
    var strong = el.querySelector('strong, b');
    if (!strong) return null;

    // Check if bold is at the start (allow whitespace before)
    var textBefore = '';
    var node = strong;
    while (node.previousSibling) {
      node = node.previousSibling;
      if (node.nodeType === 3) {
        textBefore = node.textContent + textBefore;
      } else if (node.nodeType === 1) {
        return null; // Another element before bold = not leading
      }
    }
    // Only whitespace before bold is OK
    if (textBefore.trim() !== '') return null;

    return strong;
  }

  // Helper: Check if bold element is a question
  function isQuestion(boldEl) {
    if (!boldEl) return false;
    var text = boldEl.textContent.trim();
    return text.endsWith('?');
  }

  // --- Detect FAQ split point ---
  // Strategy 1: heading containing "frag" or "faq" (case-insensitive)
  let splitIndex = children.findIndex(function (el) {
    if (/^H[2-6]$/.test(el.tagName)) {
      var text = el.textContent.toLowerCase();
      return text.includes('frag') || text.includes('faq') || text.includes('häufig');
    }
    return false;
  });

  // Strategy 2: first <p> starting with <strong>/<b> ending in "?"
  if (splitIndex === -1) {
    splitIndex = children.findIndex(function (el) {
      if (el.tagName !== 'P') return false;
      var bold = getLeadingBold(el);
      return isQuestion(bold);
    });
  }

  if (splitIndex === -1) return;

  // --- Extract FAQ elements from prose ---
  var faqElements = children.slice(splitIndex);

  // Remove the FAQ heading from prose (it becomes the accordion heading)
  var faqSectionHeading = null;
  if (/^H[2-6]$/.test(faqElements[0].tagName)) {
    faqSectionHeading = faqElements.shift();
  }

  // --- Parse Q&A pairs ---
  // Pattern A: <p><strong>Question?</strong> Answer text...</p>
  // Pattern B: <p><strong>Question?</strong></p> followed by <p>Answer...</p>
  // Pattern C: <h3>Question?</h3> followed by <p>Answer...</p>
  var pairs = [];
  var i = 0;

  while (i < faqElements.length) {
    var el = faqElements[i];

    // Pattern C: Heading as question (H3, H4, H5, H6)
    if (/^H[3-6]$/.test(el.tagName)) {
      var headingText = el.textContent.trim();
      if (headingText.endsWith('?')) {
        var question = headingText;
        var answerParts = [];

        // Collect following paragraphs as answer until next heading or bold question
        i++;
        while (i < faqElements.length) {
          var next = faqElements[i];
          // Stop at next heading
          if (/^H[2-6]$/.test(next.tagName)) break;
          // Stop at bold question paragraph
          if (next.tagName === 'P') {
            var nextBold = getLeadingBold(next);
            if (isQuestion(nextBold)) break;
            answerParts.push(next.innerHTML);
          }
          i++;
        }

        if (answerParts.length > 0) {
          pairs.push({ question: question, answer: answerParts.join('') });
        }
        continue;
      }
    }

    // Pattern A & B: Bold text in paragraph as question
    if (el.tagName === 'P') {
      var bold = getLeadingBold(el);
      if (isQuestion(bold)) {
        var question = bold.textContent.trim();

        // Check if answer is in the same <p> or the next one(s)
        var answerParts = [];

        // Remove the bold from a cloned node to get remaining text
        var clone = el.cloneNode(true);
        var cloneBold = clone.querySelector('strong, b');
        if (cloneBold) cloneBold.remove();
        var remainingText = clone.innerHTML.trim();
        // Remove leading <br> tags
        remainingText = remainingText.replace(/^(<br\s*\/?>)+/i, '').trim();

        if (remainingText) {
          answerParts.push(remainingText);
        }

        // Collect following non-question paragraphs as part of the answer
        i++;
        while (i < faqElements.length) {
          var next = faqElements[i];
          // Stop at headings
          if (/^H[2-6]$/.test(next.tagName)) break;
          if (next.tagName !== 'P') break;
          var nextBold = getLeadingBold(next);
          if (isQuestion(nextBold)) break;
          answerParts.push(next.innerHTML);
          i++;
        }

        if (answerParts.length > 0) {
          pairs.push({ question: question, answer: answerParts.join('') });
        }
        continue;
      }
    }
    i++;
  }

  if (pairs.length === 0) return;

  // --- Remove FAQ elements from prose ---
  if (faqSectionHeading && faqSectionHeading.parentNode) {
    faqSectionHeading.parentNode.removeChild(faqSectionHeading);
  }
  faqElements.forEach(function (el) {
    if (el.parentNode) el.parentNode.removeChild(el);
  });

  // --- Build FAQ accordion ---
  var html = '';

  if (faqHeadingText) {
    html += '<h3 class="fh-collection-seo__faq-heading">' + faqHeadingText + '</h3>';
  }

  var chevron = '<span class="fh-faq__icon" aria-hidden="true"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg></span>';

  pairs.forEach(function (pair) {
    html += '<details class="fh-faq__item">' +
      '<summary class="fh-faq__question">' +
        '<span class="fh-faq__question-text">' + pair.question + '</span>' +
        chevron +
      '</summary>' +
      '<div class="fh-faq__answer">' +
        '<div class="fh-faq__answer-content">' +
          '<p>' + pair.answer + '</p>' +
        '</div>' +
      '</div>' +
    '</details>';
  });

  faqContainer.innerHTML = html;

  // --- Exclusive accordion: close others when one opens ---
  var items = faqContainer.querySelectorAll('.fh-faq__item');
  items.forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (!item.open) return;
      items.forEach(function (other) {
        if (other !== item && other.open) other.removeAttribute('open');
      });
    });
  });

  // --- Inject FAQPage JSON-LD structured data ---
  var faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    'mainEntity': pairs.map(function (pair) {
      var tmp = document.createElement('div');
      tmp.innerHTML = pair.answer;
      var answerText = tmp.textContent || tmp.innerText || '';
      return {
        '@type': 'Question',
        'name': pair.question,
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': answerText.trim()
        }
      };
    })
  };
  var script = document.createElement('script');
  script.type = 'application/ld+json';
  script.textContent = JSON.stringify(faqSchema);
  document.head.appendChild(script);
})();
